var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailFilledWhite = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8593 3.17871L11.0068 7.99993L15.8593 12.8211C15.947 12.6378 16.0002 12.4351 16.0002 12.2187V3.78118C16.0002 3.56471 15.947 3.36205 15.8593 3.17871Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5937 2.375H1.40618C1.18971 2.375 0.987055 2.42822 0.803711 2.51594L7.00568 8.68666C7.55406 9.23503 8.4458 9.23503 8.99418 8.68666L15.1961 2.51594C15.0128 2.42822 14.8101 2.375 14.5937 2.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.140938 3.17871C0.0532188 3.36205 0 3.56471 0 3.78118V12.2187C0 12.4351 0.0532188 12.6378 0.140938 12.8211L4.99341 7.99993L0.140938 3.17871Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3437 8.66309L9.65702 9.34974C8.7433 10.2635 7.25652 10.2635 6.3428 9.34974L5.65618 8.66309L0.803711 13.4843C0.987055 13.572 1.18971 13.6252 1.40618 13.6252H14.5937C14.8101 13.6252 15.0128 13.572 15.1961 13.4843L10.3437 8.66309Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailFilledWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emailFilledWhite.40e07b0dfe3805d093d959edce0f9269.svg";